<template>
  <div class="flex-c">
    <el-button
      icon="el-icon-download"
      size="small"
      type="primary"
      style="margin: 0 10px 10px 0"
      @click="operationBtn"
    >{{ $t('receivablePayable.DownloadTheTemplate') }}</el-button>
    <upload-excel
      :on-success="importLogistics"
      :but-name="$t('basicData.BulkImport')"
    />
  </div>
</template>

<script>
import uploadExcel from '@/components/UploadExcel';
import { saveAs } from 'file-saver';

const ExcelJS = require('exceljs');

const MAX_LENGTH = 100000; // 最大导入长度

export default {
  name: 'BatchDelOrder',
  components: {
    uploadExcel
  },
  props: {
    // 费用类型
    feeTypeOption: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {

    };
  },
  created() {

  },
  methods: {
    // 下载模板
    operationBtn() {
      const that = this;
      async function ddd() {
        const wb = new ExcelJS.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');
        const Sheet2 = wb.addWorksheet('Sheet2');
        const Sheet3 = wb.addWorksheet('Sheet3');
        Sheet1.columns = [
          {
            header: '*业务单号',
            key: 'waybillNumber',
            width: 40
          },
          {
            header: '*订单号',
            key: 'orderNumber',
            width: 40
          },
          {
            header: '*业务类型',
            key: 'businessType',
            width: 40
          },
          {
            header: '*费用类型',
            key: 'feeCode',
            width: 40
          }
        ];
        Sheet1.getCell('A2').value = 'número do negócio';
        Sheet1.getCell('B2').value = 'Número do pedido';
        Sheet1.getCell('C2').value = 'Tipo de negócio';
        Sheet1.getCell('D2').value = 'Nome da taxa';
        // Sheet1.getCell('E2').value = 'Taxas a receber';
        // Sheet1.getCell('F2').value = 'Hora da ocorrência (Formato: 2022-01-01 00:00:00)';
        // Sheet1.getCell('G2').value = 'Observações';
        Sheet1.mergeCells('A3:D3');
        Sheet1.getCell('A3').value = `1、每次仅导入${MAX_LENGTH}条 / Importar apenas ${MAX_LENGTH} itens de cada vez
          2、必填 / Obrigatório
          3、不可更改此模板 / Esse modelo não pode ser alterado`;
        Sheet1.getRow(3).getCell(4).font = {
          color: { argb: 'ff0000' }
        };

        Sheet2.columns = [
          {
            header: that.$t('collectionCenter.businessT'), // 业务类型,
            key: 'businessType',
            width: 40
          }
        ];
        const Sheet2_data = [
          {
            businessType: that.$t('collectionCenter.lanshou') + '-' + 1, // 揽收
            width: 20
          },
          {
            businessType: that.$t('collectionCenter.expressDelivery') + '-' + 0, // 快递
            width: 20
          },
          {
            businessType: that.$t('collectionCenter.dispatch') + '-' + 2, // 派送
            width: 20
          }
        ];
        Sheet2.addRows(Sheet2_data);

        Sheet3.columns = [
          {
            header: that.$t('basicData.ExpenseType'), // '费用类型',
            key: 'feeCode',
            width: 40
          }
        ];
        const Sheet3_data = [];
        that.feeTypeOption.map(item => {
          Sheet3_data.push({
            feeCode: item.displayName + '-' + item.code,
            width: 20
          });
        });
        Sheet3.addRows(Sheet3_data);

        new Array(50000).fill(0).forEach((_, idx) => {
          const row = idx + 2;

          // 网点
          Sheet1.getCell(row, 3).dataValidation = {
            type: 'list',
            formulae: [`=Sheet2!$A$2:$A${Sheet2_data.length + 1}`]
          };
          // 业务类型
          Sheet1.getCell(row, 4).dataValidation = {
            type: 'list',
            formulae: [`=Sheet3!$A$2:$A${Sheet3_data.length + 1}`]
          };
        });
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/octet-stream'
        });
        const saveName = that.$t('receivablePayable.BatchDeleteExpensesByOrderNo') + '.xlsx';
        saveAs(blob, saveName);
      }
      ddd();
    },

    // 导入
    importLogistics(arr) {
      const header = arr[0].header;
      const arrData = arr[0].results.splice(2);
      const headObj = [
        'waybillNumber', // 业务单号
        'orderNumber', // 订单号
        'businessType', // 业务类型
        'feeCode' // 费用类型
        // 'fee', // 金额
        // 'operateTime', // '业务时间(格式：2022-01-01 00:00:00)'
        // 'remark' // 备注
      ];
      const dataArrList = [];
      arrData.map((item, ind) => {
        const keyArr = [];
        const data = {};
        header.map(list => {
          data[list] = (item[list] !== '' && item[list] !== null && item[list] !== undefined) ? item[list] : '';
        });
        dataArrList.push(data);
        Object.keys(item).forEach((key) => {
          keyArr.push(key);
        });
      });
      if (dataArrList.length > 100000) {
        this.$message.error(this.$t('receivablePayable.Only100000PiecesImport'));
        return;
      }
      const dataList = [];
      dataArrList.map((item, ind) => {
        const data = {};
        Object.keys(item).forEach((key, i) => {
          if (
            headObj[i] === 'businessType' ||
            headObj[i] === 'feeCode'
          ) {
            if (item[key]) {
              const index = item[key].lastIndexOf('-');
              data[headObj[i]] = item[key].slice(index + 1);
            } else {
              data[headObj[i]] = '';
            }
          } else if (headObj[i] === 'operateTime') {
            data[headObj[i]] = item[key];
          } else {
            data[headObj[i]] = item[key] ? item[key] : '';
          }
        });
        dataList.push(data);
      });
      console.log(dataList, '导入数据');
      this.$emit('importDelOrder', dataList);
    }
  }
};
</script>

<style scoped>
.flex-c {
  display: flex;
  flex-wrap: wrap;
}
</style>
